import { findByProp } from './index';
import { mapStandaloneItems, splitMenuList, sortByMenuOrder } from './splitMenuList';

/**
 * Groups the flat backend menu (leftNavMenu) into top-level entries.
 * Items with parent === null become standalone links; every other item
 * is bucketed under a group named after its `parent` translation key.
 *
 * `aliasMap` lets two backend parent keys share one visual tab (e.g. folding
 * "internal employee" into "employees") while each child keeps its real
 * `parent` value, so the UI can still tell which original group it came from
 * (used to split a merged group into columns).
 * @param {Array} list - Raw menu array from the backend (roles[0].menu).
 * @param {Object} [aliasMap] - Map of parent translation key -> parent translation key to merge into.
 * @returns {Array} Groups sorted by menuOrder, each with a `children` array.
 */
export const buildMenuGroups = (list, aliasMap = {}) => {
  const resolveCategory = (parentKey) => aliasMap[parentKey] || parentKey;
  const { standaloneItems, childItems } = splitMenuList(list);

  const parents = mapStandaloneItems(standaloneItems, 'children');

  childItems.forEach((item) => {
    const category = resolveCategory(item.parent);
    const idx = findByProp(parents, category, 'category');
    if (idx < 0) {
      parents.push({ category, optionPath: '', children: [], menuOrder: item.menuOrder });
    }
  });

  parents.sort(sortByMenuOrder);
  childItems.sort(sortByMenuOrder);

  parents.forEach((parent) => {
    childItems.forEach((item) => {
      if (parent.category === resolveCategory(item.parent)) {
        parent.children.push(item);
      }
    });
  });

  return parents;
};

export default buildMenuGroups;
